import { Form, TextArea } from "semantic-ui-react";

import { MultiLineParagraph } from "components/lib/UI";

import { FieldProps } from "./FieldProps";

const LongText = ({
  field,
  fieldValue = "",
  updateIdea,
  isEditing,
}: FieldProps) => {
  if (!isEditing) return <MultiLineParagraph content={fieldValue} />;
  return (
    <Form>
      <TextArea
        value={fieldValue}
        onChange={(_e, { value }) => updateIdea(value, ["templated", field.id])}
      />
    </Form>
  );
};

export default LongText;
